class Properties {
  way: any;
}

export default function WayProperties(_properties: Properties) {
  return (
    <div>
    </div>
  );
}
